import GrizzlyScreenSG1D from './GrizzlyScreenSG1D.png';
import GrizzlyScreenSG2D from './GrizzlyScreenSG2D.png';
import GrizzlyScreenSG1D2 from './GrizzlyScreenSG1D_2.png';
import GrizzlyScreenSG2D2 from './GrizzlyScreenSG2D_2.png';

export const getImageGrizzlyScreenSG = (decks: number) => {
  switch (decks) {
    case 1:
      return GrizzlyScreenSG1D;
    case 2:
      return GrizzlyScreenSG2D;
    default:
      return GrizzlyScreenSG1D;
  }
};

export const getImageGrizzlyScreenSG2 = (decks: number) => {
  switch (decks) {
    case 1:
      return GrizzlyScreenSG1D2;
    case 2:
      return GrizzlyScreenSG2D2;
    default:
      return GrizzlyScreenSG1D2;
  }
};
